module.exports = __webpack_public_path__ + "static/media/search.f6e43c55.svg";